import { render, staticRenderFns } from "./CompareKits.vue?vue&type=template&id=035d2293&scoped=true&"
import script from "./CompareKits.vue?vue&type=script&lang=js&"
export * from "./CompareKits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035d2293",
  null
  
)

export default component.exports